import getStatusFromError from '@lib/utils/getStatusFromError';
import { ErrorPageStatusEnum } from '@lib/components/ErrorPage/enums';
import { TIMEOUT_ERROR } from '@lib/constants/fetch';
import { ErrorLike } from '@apollo/client';

export default function isErrorTimeoutError(error?: ErrorLike) {
  const errorStatus = error ? getStatusFromError(error) : undefined;
  return (
    errorStatus === ErrorPageStatusEnum.Status503 ||
    error?.message === TIMEOUT_ERROR
  );
}
